/* eslint-disable react/prop-types */
/* eslint-disable import/no-cycle */
import React, { useCallback, useContext } from 'react';
import { styled } from '@elliemae/ds-system';
import { DSButtonV2 } from '@elliemae/ds-button-v2';
import { ChevronSmallDown } from '@elliemae/ds-icons';
import { useOwnerProps } from '@elliemae/ds-props-helpers';
import ComboBoxContext from '../ComboBoxCTX.js';
import { ComboboxDataTestid } from '../ComboboxDataTestids.js';
import { DSFormComboboxName, FORM_COMBOBOX_SLOTS } from '../constants/index.js';

const StyledDropDownButton = styled(DSButtonV2, {
  name: DSFormComboboxName,
  slot: FORM_COMBOBOX_SLOTS.DROPDOWN_BUTTON,
})<{ applyAriaDisabled: boolean }>`
  &:focus::after {
    border: none;
  }
  &:hover:not(:disabled) {
    background-color: transparent;
  }

  & svg {
    fill: ${({ theme, disabled, readOnly, applyAriaDisabled }) =>
      disabled || readOnly || applyAriaDisabled ? theme.colors.neutral['400'] : theme.colors.brand['600']};
  }

  ${({ applyAriaDisabled }) => applyAriaDisabled && `cursor: not-allowed`}
`;

export const DropdownIndicator = (): JSX.Element => {
  const {
    props,
    props: { disabled, applyAriaDisabled, readOnly, isMenuOpenableWithReadOnly },
    menuState,
    instanceUid,
  } = useContext(ComboBoxContext);

  const { getOwnerProps, getOwnerPropsArguments } = useOwnerProps(props);

  const handleOnClick: (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>) => void =
    useCallback((e) => {
      e.preventDefault();
    }, []);

  return (
    <StyledDropDownButton
      getOwnerProps={getOwnerProps}
      getOwnerPropsArguments={getOwnerPropsArguments}
      onClick={handleOnClick}
      data-testid={ComboboxDataTestid.DROPDOWN}
      aria-controls={`combo-listbox-${instanceUid}`}
      aria-labelledby="combo-label"
      disabled={disabled}
      aria-disabled={readOnly && !isMenuOpenableWithReadOnly} // button never use readOnly attribute
      aria-expanded={menuState}
      aria-haspopup="listbox"
      aria-hidden
      buttonType="icon"
      tabIndex={-1}
      size="s"
      applyAriaDisabled={applyAriaDisabled}
    >
      <ChevronSmallDown size="s" />
    </StyledDropDownButton>
  );
};
